export enum BasketComponentState {
  Initial = 0,
  Editing = 1
}